import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import { Typography, IconButton, Box, Tooltip } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import moment from 'moment';
import ReferralDetails from '../../components/Referrals/ReferralDetails/ReferralDetails';
import PageContent from '../../components/PageStructure/PageContent/PageContent';
import PageHeader from '../../components/PageStructure/PageHeader/PageHeader';
import InnerContent from '../../components/PageStructure/InnerContent/InnerContent';
import globals from '../../globals/communityGlobals';
import { doubleActionPrevent, formatNhs } from '../../utils/helpers';

const locale = globals.getArea('referrals');

class ReferralCreate extends React.Component {
  componentDidMount = () => {
    const { match, getPatientData } = this.props;
    getPatientData(match.params.patientId);
  };

  handleGoBack = () => {
    this.props.goBack();
  };

  handleNavigate = url => () => {
    this.props.navigate(url);
  };

  handleSave = doubleActionPrevent.bind(this)(
    'Save',
    async model => {
      const { createReferral, match } = this.props;
      await createReferral({
        patientId: match.params.patientId,
        locationTypeId: model.locationTypeId,
        referenceCodeId: model.referenceCodeId,
        dateReceived: moment(model.referralReceived).format(globals.dateFormats.date),
        priorityId: model.referralPriorityId,
        sourceId: model.referralSourceId,
        serviceId: model.referralServiceId,
        orgUnitIds: [model.allocatedToTeams],
        pasReferralId: model.pasReferralId,
      });
    },
    () => {
      const { navigate, match } = this.props;
      navigate(`/Patients/${match.params.patientId}/Referrals`);
    },
  );

  render() {
    const {
      pageTitle,
      match,
      patient,
      navigate,
      canAddTreatments,
      canAddReferrals,
      canEditTreatments,
      canEditReferrals,
    } = this.props;
    return (
      <PageContent pageTitle={pageTitle} permanentSidePanel>
        <div className="flex-page-content content-wrapper">
          <PageHeader>
            <Box className="title-section" display="flex" alignItems="center" px={2} py={1}>
              <Box>
                <Tooltip title={locale.getMsg('back')}>
                  <IconButton
                    className="back-btn"
                    aria-label="back"
                    size="small"
                    color="primary"
                    onClick={this.handleGoBack}
                  >
                    <ArrowBackIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box flexGrow={1}>
                <Typography variant="h3">{locale.getMsg('createPageHeader')}</Typography>
                <Typography variant="h6">
                  {patient && `${patient.patientFullName} - NHS  Number: ${formatNhs(patient.nhsNumber)}`}
                </Typography>
              </Box>
              <Box>
                <RaisedButton
                  onClick={this.handleNavigate(`/Patients/${match.params.patientId}/Referrals`)}
                  label={locale.getMsg('viewReferrals')}
                  primary
                />
              </Box>
            </Box>
          </PageHeader>
          <InnerContent>
            <Box display="flex" px={2} py={1}>
              <Box flexGrow={1}>
                <ReferralDetails
                  handleSave={this.handleSave}
                  navigate={navigate}
                  canEdit={canAddReferrals}
                  canAddTreatments={canAddTreatments}
                  canEditTreatments={canEditTreatments}
                  canEditReferrals={canEditReferrals}
                />
              </Box>
            </Box>
          </InnerContent>
        </div>
      </PageContent>
    );
  }
}

ReferralCreate.defaultProps = {
  failureMessage: '',
  patient: null,
};

ReferralCreate.propTypes = {
  canAddTreatments: PropTypes.bool.isRequired,
  canAddReferrals: PropTypes.bool.isRequired,
  canEditTreatments: PropTypes.bool.isRequired,
  canEditReferrals: PropTypes.bool.isRequired,
  pageTitle: PropTypes.string.isRequired,
  goBack: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  createReferral: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      referralId: PropTypes.number,
    }).isRequired,
  }).isRequired,
  getPatientData: PropTypes.func.isRequired,
  patient: PropTypes.shape({
    patientFullName: PropTypes.string,
    nhsNumber: PropTypes.string,
    addresses: PropTypes.arrayOf(
      PropTypes.shape({
        addressLine1: PropTypes.string,
        addressLine2: PropTypes.string,
        addressLine3: PropTypes.string,
        postCode: PropTypes.string,
      }),
    ),
  }),
};

export default ReferralCreate;
